import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';

import MaterialAvatar from '../../../../../../components/MaterialAvatar';
import { textCapitalized } from '../../../../../../utils/general';

function Contact({ contact, selectedContactId, setSelectedContactId }) {
  return (
    <ListItem
      key={contact.id}
      button
      disableRipple
      alignItems="flex-start"
      className="contact-item"
      selected={contact.id === selectedContactId}
      onClick={() => setSelectedContactId(contact.id)}
    >
      <ListItemAvatar>
        <MaterialAvatar
          badgeType="online"
          badgeVariant="dot"
          classes="contact-profile-avatar"
          member_id={contact.contact_member_id}
          src={contact.amera_avatar_url}
          firstName={contact.first_name}
          lastName={contact.last_name}
        />
      </ListItemAvatar>
      <ListItemText
        primary={
          textCapitalized(contact.first_name) +
          ' ' +
          textCapitalized(contact.last_name)
        }
        // secondary={contact.latestMessageText}
      />
    </ListItem>
  );
}

export default Contact;
